'use client';

import { useEffect } from 'react';

import LoadingPage from '../Member/LoadingPage';
import { useHistoryMethod } from '../utils/hook/useHistoryMethod';

export default function NotFound() {
  const history = useHistoryMethod();

  useEffect(() => {
    history.replace('/main');
  }, []);

  return <LoadingPage />;
}
